var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import DataLayer from "@lonelyplanet/dotcom-core/dist/containers/dataLayer";
import { lodging, poi } from "@lonelyplanet/open-planet-node/dist/openPlanetTypes";
import { Helmet } from "@lonelyplanet/travel-agent/dist/helmet";
import ModalWrapper from "backpack-ui/dist/components/modal/wrapper";
import { MultiStepWrapper } from "backpack-ui/dist/components/multiStep";
import * as Cookie from "js-cookie";
import "photoswipe/dist/photoswipe.css";
import { StyleRoot } from "radium"; /* TODO Remove this as soon as possible */
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Asset from "../../shared/components/asset";
import { Bookmark } from "../../shared/components/bookmark";
import { withInitialState } from "../../shared/containers/withInitialState";
import * as bookmarkActions from "./actions/bookmarks";
import * as nearbyPoisActions from "./actions/nearbyPois";
import * as userActions from "./actions/user";
import { Schema } from "./components/schema";
import { DetailPageInitialState } from "./initialState/detailPageInitialState";
import PageLodging from "./lodging";
import PagePartnerActivity from "./partnerActivity";
import Toast from "./patterns/toast";
import PagePoi from "./poi";
import buildPlaceDimensions from "./utils/buildPlaceDimensions";
var components = {
    lodging: PageLodging,
    partner_activity: PagePartnerActivity,
    poi: PagePoi,
};
var DetailComponent = /** @class */ (function (_super) {
    __extends(DetailComponent, _super);
    function DetailComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.updateBookmark = _this.updateBookmark.bind(_this);
        _this.state = {
            error: false,
            isDOM: typeof window !== "undefined",
            lpCurrency: "USD",
        };
        return _this;
    }
    DetailComponent.prototype.componentDidCatch = function (error) {
        this.setState({
            error: error,
        });
    };
    DetailComponent.prototype.componentDidMount = function () {
        var view = this.props.view;
        if ((view.poi.type === lodging || view.poi.type === poi) &&
            this.state.isDOM &&
            !this.props.nearbyPois.mapMarkers.length) {
            var id = view.poi.type === lodging ? (view.poi.poi && view.poi.poi.id) : view.poi.id;
            if (id) {
                this.props.nearbyActions.fetchNearbyPois(id);
            }
        }
        if (this.state.isDOM) {
            this.setState({ lpCurrency: Cookie.get("lpCurrency") || "USD" });
        }
        this.props.userActions.fetchUser(view.authHost);
    };
    DetailComponent.prototype.componentWillReceiveProps = function (nextProps, prevState) {
        // Fetch bookmarks after the user id is fetched
        if (!this.props.user.id && nextProps.user.id) {
            this.fetchBookmarks(nextProps.user.id);
        }
    };
    DetailComponent.prototype.render = function () {
        var _this = this;
        var _a = this.state, error = _a.error, isDOM = _a.isDOM, lpCurrency = _a.lpCurrency;
        if (error) {
            return React.createElement("div", null, error);
        }
        var _b = this.props, bookmarks = _b.bookmarks, nearbyPois = _b.nearbyPois, user = _b.user, view = _b.view;
        var Component = components[view.poi.type];
        var dataLayer = __assign({ cd10_ArticleName: null, cd21_AtlasDestination: null, cd6_SiteSection: "destinations", cd7_Topic: "Things to Do", cd8_BookingType: null, cd9_TestExperience: null, content_group_1: "content", content_group_2: "pois", content_group_3: null, content_group_4: null, content_group_5: null, page_type: "content page", poiName: view.poi.name, poiType: view.poi.poiType, poi_atlas_id: view.poi.id, resource: view.poi.type, site_section: "destinations" }, buildPlaceDimensions(view.places));
        return (React.createElement(React.Fragment, null,
            React.createElement(Helmet, null,
                React.createElement("title", null, view.meta.title),
                React.createElement("meta", { name: "title", content: view.meta.title }),
                React.createElement("meta", { name: "description", content: view.meta.description.truncated }),
                React.createElement("meta", { property: "og:title", content: view.meta.title }),
                React.createElement("meta", { property: "og:description", content: view.meta.description.truncated }),
                React.createElement("meta", { className: "swiftype", name: "title", "data-type": "string", content: view.meta.title }),
                React.createElement("meta", { className: "swiftype", name: "body", "data-type": "text", content: view.meta.description.full }),
                React.createElement("meta", { className: "swiftype", name: "op-id", "data-type": "string", content: view.poi.id }),
                React.createElement("meta", { className: "swiftype", name: "op-type", "data-type": "string", content: view.poi.type }),
                React.createElement("link", { rel: "canonical", href: view.meta.canonical }),
                nearbyPois && nearbyPois.mapMarkers &&
                    React.createElement("link", { rel: "stylesheet", href: "https://unpkg.com/leaflet@1.3.1/dist/leaflet.css", type: "text/css" })),
            React.createElement(DataLayer, { data: dataLayer }),
            React.createElement(ModalWrapper, null, function (isOpen, toggle) { return (React.createElement(React.Fragment, null,
                (view.poi.type === poi || view.poi.type === lodging) && (React.createElement(Schema.Review, { poi: view.poi, canonicalUrl: view.location.pathname })),
                React.createElement(Component, __assign({}, view, { isDOM: isDOM, dataLayer: dataLayer, lpCurrency: lpCurrency, nearbyMapMarkers: nearbyPois && nearbyPois.mapMarkers, bookmarked: bookmarks.isBookmarked, onClickBookmark: function () {
                        if (!user.id) {
                            window.location.hash = "#login";
                        }
                        else {
                            toggle();
                        }
                    } })),
                React.createElement(MultiStepWrapper, { totalSteps: 2 }, function (currentStep, goToNextStep, goToPreviousStep, setCurrentStep) { return (React.createElement(StyleRoot, null,
                    React.createElement(Bookmark.ModalAdd, { currentStep: currentStep, goToNextStep: goToNextStep, goToPreviousStep: goToPreviousStep, setCurrentStep: setCurrentStep, isOpen: isOpen, toggle: toggle, updateBookmark: _this.updateBookmark, lists: bookmarks.bookmarkLists, poi: view.poi, pois: bookmarks.resources }))); }))); }),
            React.createElement(Toast, { buttonLabel: this.props.toast.buttonLabel, message: this.props.toast.message, type: this.props.toast.type, url: this.props.toast.url, visible: this.props.toast.visible }),
            React.createElement(Asset, { src: "app.js" })));
    };
    DetailComponent.prototype.fetchBookmarks = function (userId) {
        var _a = this.props, actions = _a.bookmarkActions, _b = _a.view, profileHost = _b.profileHost, item = _b.poi;
        actions.fetchBookmarkLists(profileHost, userId, item.id);
    };
    DetailComponent.prototype.updateBookmark = function (bookmark, list) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, actions, _b, profileHost, item, user;
            return __generator(this, function (_c) {
                _a = this.props, actions = _a.bookmarkActions, _b = _a.view, profileHost = _b.profileHost, item = _b.poi, user = _a.user;
                // The user is adding a bookmark to a new list
                if (!list.id) {
                    actions.createListAndAddBookmark(profileHost, user, list, bookmark, item);
                    // The user is adding a bookmark to an existing list which has previously contained the bookmark
                }
                else if (bookmark.id) {
                    actions.updateBookmark(profileHost, user, list, bookmark, item.id);
                    // The user is adding a new bookmark to an existing list
                }
                else {
                    actions.createBookmark(profileHost, user, list, bookmark, item);
                }
                return [2 /*return*/];
            });
        });
    };
    return DetailComponent;
}(React.PureComponent));
export { DetailComponent };
function mapStateToProps(state) {
    return {
        bookmarks: state.bookmarks,
        nearbyPois: state.nearbyPois,
        toast: state.toast,
        user: state.user,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        bookmarkActions: bindActionCreators(bookmarkActions, dispatch),
        nearbyActions: bindActionCreators(nearbyPoisActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
    };
}
var app = connect(mapStateToProps, mapDispatchToProps)(DetailComponent);
export default withInitialState(app, function (props) { return new DetailPageInitialState(props); });



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/index.tsx
// module id = vmIt
// module chunks = 2